shadow$provide[182] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Overlay:{enumerable:true, get:function() {
  return Overlay;
}}});
class Overlay {
  constructor(element, options) {
    this.element = element;
    if (typeof this.init === "function") {
      this.init(options);
    }
  }
  dispose() {
  }
}

};